import { Component, Input, OnInit } from '@angular/core';
import { EcosistemasService } from 'src/app/services/ecosistemas.service';

@Component({
  selector: 'app-leyenda',
  templateUrl: './leyenda.component.html',
  styleUrls: ['./leyenda.component.scss']
})
export class LeyendaComponent implements OnInit {

  @Input() arrleyenda: Array<any>
  @Input() map: any
  capas_tematicas: Array<any>


  toggle_leyenda: boolean;
  listaElementos: any[] = [];

  constructor(
    private ecosistemasService: EcosistemasService
  ) {
    this.ecosistemasService.capas_tematicas$.subscribe( variable => {
      this.capas_tematicas = variable
      console.log('capas_tematicas actualizadas')
      this.loadingLeyenda()
    })
    this.ecosistemasService.buttonStateChanged.subscribe((event: { buttonName: string, newState: boolean }) => {
      if (event.buttonName === 'toggle_leyenda') {
        this.toggle_leyenda = event.newState;
        // Handle the action for button1 state change
        if (!event.newState) {
          this.loadingLeyenda()
        } else {
          this.arrleyenda = [];
        }
      }
    });
    this.listaElementos.push({
      posx: 0,
      posy: 0,
    });
  }

  ngOnInit() {
    
  }

  loadingLeyenda(){
    this.arrleyenda = [];
    setTimeout(() => {
      this.map.getLayers().forEach( lyr => {
        if(lyr && lyr.get('name') != 'CapaBase'){
          const index = this.capas_tematicas.findIndex( capa => capa.name == lyr.get('name'))
          if(index != -1){
            this.arrleyenda.push({name: this.capas_tematicas[index].label, value:this.capas_tematicas[index].value})
          }
        }
        console.log(this.arrleyenda)
      });
    })
  }

}
